var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgEdit = function SvgEdit(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "TBEdit14"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.07689 2.76732L2.8945 7.43357L2.69534 9.22765L4.50041 9.21712L9.68281 4.55086L8.07689 2.76732ZM8.56719 1.51847C8.34546 1.27222 7.96608 1.25233 7.71982 1.47406L2.09154 6.5418C1.87296 6.73861 1.73427 7.00884 1.70182 7.30117L1.42828 9.76537C1.38867 10.1222 1.66914 10.4337 2.02812 10.4316L4.50741 10.4171C4.80153 10.4154 5.08479 10.3057 5.30337 10.1089L10.9317 5.04116C11.1779 4.81943 11.1978 4.44005 10.9761 4.19379L8.56719 1.51847ZM8.35065 9.24905C8.35065 8.91768 8.61928 8.64905 8.95065 8.64905H12.5301C12.8615 8.64905 13.1301 8.91768 13.1301 9.24905C13.1301 9.58042 12.8615 9.84905 12.5301 9.84905H8.95065C8.61928 9.84905 8.35065 9.58042 8.35065 9.24905ZM1.79043 11.6449C1.45906 11.6449 1.19043 11.9135 1.19043 12.2449C1.19043 12.5763 1.45906 12.8449 1.79043 12.8449H12.5748C12.9062 12.8449 13.1748 12.5763 13.1748 12.2449C13.1748 11.9135 12.9062 11.6449 12.5748 11.6449H1.79043Z",
    fill: "#62657A"
  }))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgEdit);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/edit.f656e9f0.svg";